import Home from './routes/Home.svelte';
import About from './routes/About.svelte';
import Details from './routes/Details.svelte';
import NotFound from './routes/NotFound.svelte';
import Recipe from './routes/Recipe.svelte';
import Reconstruction from './routes/Reconstruction.svelte';
import Admin from './routes/Admin.svelte';


export default {
    '/about/': About,
    '/details/:session': Details,
    '/': Home,
    '/recipe/:session/:tomography/:previewName?': Recipe,
    '/reconstruction/:session/:tomography/:dataset': Reconstruction,
    '/admin/:orgId?/:tab?': Admin,

    // The catch-all route must always be last
    '*': NotFound
};